import React, { useState } from 'react';
import {
  SearchBar,
  FilterDropdown,
  AppliedFilters,
  createFieldFilterOptions,
} from '@/components/filters';
import { Job, JobStatus, Site } from '@core/generated/gql-types';

interface JobFiltersProps {
  jobs: Job[];
  sites: Site[];
  onSearch: (query: string) => void;
  onStatusFiltersChange: (statusFilters: JobStatus[]) => void;
  onSiteFiltersChange: (siteFilters: string[]) => void;
}

export const JobFilters: React.FC<JobFiltersProps> = ({
  jobs,
  sites,
  onSearch,
  onStatusFiltersChange,
  onSiteFiltersChange,
}) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilters, setStatusFilters] = useState<string[]>([]);
  const [siteFilters, setSiteFilters] = useState<string[]>([]);

  const handleSearchChange = (query: string) => {
    setSearchQuery(query);
    onSearch(query);
  };

  const handleStatusFiltersChange = (statusFilters: string[]) => {
    setStatusFilters(statusFilters);
    onStatusFiltersChange(statusFilters as JobStatus[]);
  };

  const handleSiteFiltersChange = (siteFilters: string[]) => {
    setSiteFilters(siteFilters);
    onSiteFiltersChange(siteFilters);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <SearchBar
          searchQuery={searchQuery}
          setSearchQuery={handleSearchChange}
          placeholder="Search jobs..."
        />
        <FilterDropdown
          title="Status"
          data={jobs}
          getOptions={createFieldFilterOptions('itemStatus')}
          selectedFilters={statusFilters}
          setSelectedFilters={handleStatusFiltersChange}
        />
        <FilterDropdown
          title="Site"
          data={sites}
          getOptions={createFieldFilterOptions('name')}
          selectedFilters={siteFilters}
          setSelectedFilters={handleSiteFiltersChange}
        />
      </div>
      <AppliedFilters
        filterGroups={[
          {
            label: 'Status',
            values: statusFilters,
            setValues: handleStatusFiltersChange,
          },
          {
            label: 'Site',
            values: siteFilters,
            setValues: handleSiteFiltersChange,
          },
        ]}
      />
    </div>
  );
};
